import { Injectable } from '@angular/core';
import { AppData } from "../bundles/services.bundle";
import { PermissionHelper } from "../bundles/helpers.bundle";
import { Measures } from "../../admin/pages/measures/measures.namespace";
import { IAccount, Pagination, Page, organization } from "../bundles/models.bundle";
import { MeasuresService } from "../Resolver-Service/measures.service";
import { Resolve, } from '@angular/router';
import { takeUntil } from "rxjs/operators";
import * as $ from "jquery";

@Injectable()
export class MeasuresResolver implements Resolve<any> {
    options: Measures.Filters;
    org: Array<organization>;
    pagination: Pagination;
    page: Page;
    permissions: PermissionHelper;
    sortOptions: Array<{ key: string, value: string }>;
    selectedSort: string;

    constructor(
        private readonly measuresService: MeasuresService,

        private readonly appData: AppData
    ) {
        this.page = new Page();
        this.pagination = new Pagination();
        this.options = new Measures.Filters();
        this.appData.account
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((account: IAccount) => {
                if (account) {
                    this.page.account = account;
                    this.permissions = new PermissionHelper(this.page.account.roleId);
                }
            });
    }

    initSorting(sortBy: string) {
        this.sortOptions = Measures.sortOptions();
        const sortOptions = this.sortOptions.find((sort: any) => sort.key === sortBy);
        this.selectedSort = sortOptions.value;
    }

    initPagination(pageIndex?: number) {
        this.pagination = new Pagination();
        this.pagination.pageIndex = pageIndex;
        this.pagination.pageSize = 11;
    }

    resolve() {
        this.options.clientId = this.permissions.system ? null : this.page.account.clientId;
        this.options.userId = this.page.account.userId;
        this.initSorting("A");
        this.initPagination(1);
        const request = Object.assign($.extend(true, { roleId: this.page.account.roleId }, this.options), this.pagination);
        if(!this.options.clientId)
            return new Array<organization>();
        return this.measuresService.fetchMeasureAnalysisReport(request);
    }
}
